import { atom } from "recoil";

export const AuthCheckedState = atom({
  key: "authCheckedState",
  default: false,
});